export default __webpack_public_path__ + "static/media/andes_a_la_costa_4.b0592b06.JPG";